module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('bar-top'), _vm._v(" "), _c('alert-handler', {
    ref: "alert"
  }), _vm._v("\n  " + _vm._s(_vm.serverVersion) + "\n  "), (Object.keys(this.config).length) ? _c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('b-tabs', {
    ref: "tabs",
    attrs: {
      "small": "",
      "card": ""
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Templates"
    }
  }, _vm._l((this.config.templates), function(templ, index) {
    return _c('b-card', {
      key: templ.id,
      staticClass: "template-card",
      attrs: {
        "no-block": "",
        "header": templ.displayname,
        "header-variant": "template-header"
      }
    }, [_c('div', {
      staticClass: "dlbuttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "default"
      },
      on: {
        "click": function($event) {
          _vm.downloadTemplate(templ)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "default",
        "disabled": !_vm.files[index]
      },
      on: {
        "click": function($event) {
          _vm.uploadTemplate(templ, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-upload"
    }), _vm._v(" Upload")]), _vm._v(" "), _c('b-form-file', {
      ref: "fileinput",
      refInFor: true,
      attrs: {
        "placeholder": " "
      },
      model: {
        value: (_vm.files[index]),
        callback: function($$v) {
          _vm.$set(_vm.files, index, $$v)
        },
        expression: "files[index]"
      }
    })], 1)])
  })), _vm._v(" "), (_vm.privDeveloper) ? _c('b-tab', {
    attrs: {
      "title": "Email"
    }
  }, [_c('b-form', {
    ref: "formEmail",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', [_c('detail-field', {
    attrs: {
      "label": "SMTP Port",
      "field": "smtp_port",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "required",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "SMTP Server",
      "field": "smtp_servername",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "required",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "SMTP Username",
      "field": "smtp_username",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "ok",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "SMTP Password",
      "field": "smtp_password",
      "rec": this.config.email_config,
      "type": "password",
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "ok",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Test Email",
      "field": "test_email_address",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "email",
      "validator": _vm.email_validator
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "From: Email",
      "field": "from_email_address",
      "rec": this.config.email_config,
      "isReadOnly": !_vm.editEmail,
      "vvalidate": "required|email",
      "validator": _vm.email_validator
    }
  })], 1)]), _vm._v(" "), (!_vm.editEmail) ? _c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        _vm.editEmail = !_vm.editEmail
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Edit")]) : _vm._e(), _vm._v(" "), (_vm.editEmail) ? _c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        _vm.saveEmail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]) : _vm._e()], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aae1a5de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Config.vue
// module id = 719
// module chunks = 1